import dayjs from 'dayjs';
let relativeTime = require('dayjs/plugin/relativeTime');
let updateLocale = require('dayjs/plugin/updateLocale');

require('dayjs/locale/de');

dayjs.extend(updateLocale);
dayjs.extend(relativeTime);

(dayjs as any).updateLocale('en', {
  relativeTime: {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: '1 day',
    dd: '%d days',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years',
  },
});

export const formatDateRelative = (date: string) => {
  //return dayjs().from(dayjs(date), true);
  return date ? dayjs(date).format('HH:mm:ss DD/MM/YYYY') : '';
};
